module.exports = __webpack_public_path__ + "img/LVB.7281d01d.svg";